<div class="flex flex-col">
  @if (rows$ | async; as rows) {
    @if (rows.length === 0) {
      <div class="flex flex-col w-full justify-start items-stretch text-center">
        <p class="py-32">
          <em>No sales recorded.</em>
        </p>
      </div>
    } @else {
      <table mat-table [dataSource]="rows">
        <ng-container matColumnDef="parent">
          <th mat-header-cell *matHeaderCellDef>Sold on</th>
          <td mat-cell *matCellDef="let element">
            <ng-container [ngSwitch]="element.parent_type">
              <ng-container *ngSwitchCase="'workshopJob'">
                <a [routerLink]="['/workshop/job', element.parent_id]">
                  {{ element.parent }}
                </a>
              </ng-container>
              <ng-container *ngSwitchCase="'saleDocket'">
                <a [routerLink]="['/sale-docket', element.parent_id]">
                  {{ element.parent }}</a
                >
              </ng-container>
              <ng-container *ngSwitchCase="'docket'">
                <a [routerLink]="['/docket', element.parent_id]">
                  {{ element.parent }}
                </a>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="line_item_description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">
            {{ element.line_item_description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef>Qty</th>
          <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="unit_price">
          <th mat-header-cell *matHeaderCellDef>Unit Price</th>
          <td mat-cell *matCellDef="let element">
            {{ element.unit_price | hlCurrency | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tax_amount">
          <th mat-header-cell *matHeaderCellDef>Tax</th>
          <td mat-cell *matCellDef="let element">
            {{ element.tax_amount | hlCurrency | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total_price">
          <th mat-header-cell *matHeaderCellDef>Total Price</th>
          <td mat-cell *matCellDef="let element">
            {{ element.line_total | hlCurrency | async }}
          </td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Location</th>
          <td mat-cell *matCellDef="let element">
            {{ element.location_id | locationNameFromId | async }}
          </td>
        </ng-container>
        <ng-container matColumnDef="created_by_at">
          <th mat-header-cell *matHeaderCellDef>User / date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.created_by | userIdToName | async }}
            <small>{{ element.created_at | amDateFormat }}</small>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    }
  }
</div>
